<template>
  <div class="home-gate">
    <div v-if="!permissionsLoaded" class="home-gate__loading">
      <i class="el-icon-loading"></i>
    </div>

    <DashboardBI v-else-if="canSeeReports" />

    <section v-else class="home-gate__welcome">
      <h1 class="home-gate__title">Hola, {{ firstName }}</h1>
      <p class="home-gate__subtitle">
        Estas son las secciones de {{ businessName }} a las que tienes acceso.
      </p>

      <div v-if="shortcuts.length" class="home-gate__grid">
        <router-link
          v-for="item in shortcuts"
          :key="item.route"
          :to="{ name: item.route }"
          class="home-gate__card"
        >
          <i :class="item.icon" class="home-gate__icon"></i>
          <span class="home-gate__label">{{ item.label }}</span>
        </router-link>
      </div>

      <p v-else-if="hasMarketingAccess" class="home-gate__empty">
        Tu acceso en este negocio es al módulo de Marketing. Entra desde el menú
        <strong>Marketing</strong> de la barra superior.
      </p>
      <p v-else class="home-gate__empty">
        Todavía no tienes permisos asignados. Pídele al propietario del negocio
        que te asigne un rol desde Equipo.
      </p>
    </section>
  </div>
</template>

<script>
import { permissionsForRoute } from "@/modules/dashboard/team/routePermissions";

const DashboardBI = () =>
  import("@/modules/dashboard/reports/pages/DashboardBI");

// Accesos directos de la bienvenida (solo se muestran los permitidos).
const SHORTCUTS = [
  { route: "sales.documents", label: "Ventas", icon: "el-icon-document" },
  { route: "sales.invoices.add", label: "Nueva factura", icon: "el-icon-plus" },
  {
    route: "sales.quotes.add",
    label: "Nueva cotización",
    icon: "el-icon-edit-outline"
  },
  { route: "business.main", label: "Directorio", icon: "el-icon-user" },
  { route: "catalogue.products", label: "Productos", icon: "el-icon-goods" },
  { route: "sales.expenses", label: "Gastos", icon: "el-icon-wallet" },
  { route: "documentos", label: "Documentos", icon: "el-icon-folder" },
  { route: "agreements", label: "Contratos", icon: "el-icon-tickets" }
];

export default {
  name: "HomeGate",
  components: { DashboardBI },
  computed: {
    permissionsLoaded() {
      return this.$store.getters.permissionsLoaded;
    },
    canSeeReports() {
      return this.$store.getters.hasPermission("reports.view");
    },
    user() {
      return this.$store.getters.getUser || {};
    },
    firstName() {
      return (this.user.name || "").split(" ")[0] || "de nuevo";
    },
    businessName() {
      const ub = this.user.user_business || {};
      return ub.business_name || "tu negocio";
    },
    hasMarketingAccess() {
      return this.$store.getters.hasAnyPermission([
        "marketing.leads.view",
        "marketing.messaging.view",
        "marketing.flows.view",
        "marketing.mailing.view",
        "marketing.sites.view"
      ]);
    },
    shortcuts() {
      return SHORTCUTS.filter(item => {
        const required = permissionsForRoute(item.route);
        return !required || this.$store.getters.hasAnyPermission(required);
      });
    }
  },
  created() {
    if (!this.permissionsLoaded) this.$store.dispatch("loadMyPermissions");
  }
};
</script>

<style scoped lang="scss">
.home-gate__loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
  font-size: 28px;
  color: #3ecfb4;
}

.home-gate__welcome {
  font-family: "Plus Jakarta Sans", sans-serif;
  padding: 32px 16px;
  max-width: 960px;
}

.home-gate__title {
  color: #2d2b55;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 6px;
}

.home-gate__subtitle,
.home-gate__empty {
  color: #6b6a86;
  font-size: 15px;
  margin: 0 0 24px;
}

.home-gate__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
}

.home-gate__card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border: 1.5px solid #e6e6f0;
  border-radius: 10px;
  background: #fff;
  color: #2d2b55;
  text-decoration: none;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: #3ecfb4;
    box-shadow: 0 4px 14px rgba(45, 43, 85, 0.08);
  }
}

.home-gate__icon {
  font-size: 22px;
  color: #1d9e75;
}

.home-gate__label {
  font-weight: 600;
  font-size: 15px;
}
</style>
